import type { Ticket } from "../types/ticket.types";

type TicketPatient = {
	name: string;
	patientId: number | null;
};

const getCapitalized = (value: string): string => {
	const trimmedValue = value.trim().toLowerCase();
	if (!trimmedValue) {
		return "";
	}
	return `${trimmedValue[0]?.toUpperCase() ?? ""}${trimmedValue.slice(1)}`;
};

const getTicketPatientName = (ticket: Ticket): string => {
	const firstName = getCapitalized(ticket.command?.patient?.firstName ?? "");
	const lastName = getCapitalized(ticket.command?.patient?.lastName ?? "");
	const name = `${firstName} ${lastName}`.trim();
	if (!name) {
		return "---";
	}
	return name;
};

export const getTicketPatient = (ticket: Ticket): TicketPatient => {
	return {
		name: getTicketPatientName(ticket),
		patientId: ticket.command?.patientId ?? null,
	};
};
